module.exports = __webpack_public_path__ + "img/non-potable-water.f5bfe042.png";